export const HeaderText = () => {
    return (
        <div>
            <p className="headerText"><span className="titleSpan">Chambers Electrical and Communications</span><br />
            <span className="bodySpan">Electrical Contractor</span>
            </p>
        </div>
    );
};

export const BodyTextZero = () => {
    return (
        <div className="btz">
            <p>
            Revitalizing Workspaces.<br/>
            Modernizing Residentials.
            </p>
        </div>
    );
};

export const BodyTextScrolled = () => {
    return (
        <div className="bts">
            <p>
            Whether you need commercial construc3on, wiring, panel upgrades, or new construc3on for a home addi3on, Chambers Electrical and Communica3ons’ licensed electricians and data communica3on technicians have the necessary skills to complete any task. 
            We pride ourselves on being able to offer our customers the best in electrical and data communica3on services.
            </p>
            <button>
                Contact Us
            </button>
        </div>
    );
}

